<template>
  <!-- TableWrapper hides the least important columns as the viewport narrows. -->
  <table-wrapper>
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      loading-text="Loading your mailboxes…"
      item-key="id"
      sort-by="email"
      :footer-props="footerProps"
    >
      <template v-slot:item.email="{ item }">
        <span class="font-weight-medium">{{ item.email }}</span>
      </template>

      <template v-slot:item.storage="{ item }">
        <!-- Percentage over the figures, no bar (AM-1106). cPanel sends the
             string 'None' rather than a number when the quota is unlimited,
             where a percentage means nothing. -->
        <div class="font-weight-medium">{{ item.unlimited ? 'Unlimited' : `${quotaPercentage(item.diskusedpercent_float)}%` }}</div>
        <div class="text-no-wrap text--secondary">
          {{ item.humandiskused }} / {{ item.unlimited ? '∞' : item.humandiskquota }}
        </div>
      </template>

      <template v-slot:item.status="{ item }">
        <v-icon small class="pb-1" :color="statusColor(item.status)" aria-hidden="true">mdi-circle</v-icon>
        {{ item.status }}
      </template>

      <template v-slot:item.actions="{ item }">
        <div class="d-flex align-center justify-end">
          <gg-btn
            secondary
            small
            class="mr-2 text-no-wrap"
            :aria-label="`Open webmail for ${item.email}`"
            @click="$emit('action', { action: 'webmail', mailbox: item })"
          >
            Webmail
            <v-icon small class="ml-1" aria-hidden="true">mdi-open-in-new</v-icon>
          </gg-btn>
          <mailbox-actions-menu :mailbox="item" @action="$emit('action', $event)" />
        </div>
      </template>

      <template v-slot:no-data>
        <div class="py-8 text-center">
          <template v-if="filtered">
            <p class="mb-2 font-weight-medium">No mailboxes match your filters.</p>
            <gg-btn small tertiary @click="$emit('clear-filters')">Clear filters</gg-btn>
          </template>
          <template v-else>
            <p class="mb-2 font-weight-medium">This account doesn't have any mailboxes yet.</p>
            <p class="mb-0">Use Add Mailbox above to add the first one.</p>
          </template>
        </div>
      </template>
    </v-data-table>
  </table-wrapper>
</template>

<script>
import TableWrapper from '@/components/Common/TableWrapper'
import MailboxActionsMenu from '@/components/Email/MailboxActionsMenu'
import { statusColor } from '@/helpers/helpers'

export default {
  name: 'MailboxesTable',
  components: {
    TableWrapper,
    MailboxActionsMenu,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    // Drives which of the two empty states is shown.
    filtered: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      // No Email Plan column: the table lists a single account, where every
      // mailbox shares the account's plan and the header already shows it. No
      // Domain column either (AM-1106): the address already carries it.
      headers: [
        { text: 'Mailbox', value: 'email' },
        { text: 'Storage', value: 'storage', sortable: false },
        { text: 'Aliases', value: 'aliases' },
        { text: 'Status', value: 'status' },
        { text: 'Actions', value: 'actions', align: 'end', sortable: false },
      ],
      footerProps: {
        'items-per-page-options': [10, 25, 50, -1],
      },
    }
  },
  methods: {
    statusColor,
    // Two decimals at most, without trailing zeros: 0, 12.5, 99.99.
    quotaPercentage (value) {
      const percent = Math.min(Number(value) || 0, 100)
      return Number(percent.toFixed(2))
    },
  },
}
</script>
